var _style, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t {fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,21H3c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h18c1.1,0,2,0.9,2,2v14C23,20.1,22.1,21,21,21z M21,5H3v14h18V5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.3,17.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9,11.1l-6-3.5C9.1,7.2,8.2,7.7,8.2,8.5v7c0,0.8,0.9,1.4,1.6,0.9l6-3.5C16.6,12.5,16.6,11.5,15.9,11.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.2e9c761ca8acd8b46303c75e9f97e8f1.svg";
export { ForwardRef as ReactComponent };